import React from 'react';
import { Link } from 'react-router-dom';
import TitleLogo from '~/assets/img/tryon-title-logo.png';
import { AiFillFacebook, AiFillLinkedin } from 'react-icons/ai';
import config from '../../config';

const Footer = () => {
    return (
        <footer className="mb-0 bg-gradient-to-b from-gray-50 to-gray-150 font-light text-gray-410">
            <div className="container flex flex-col">
                <div className="flex justify-between items-center border-b-2 border-gray-290 h-44 text-sm">
                    <Link to="/">
                        <img src={TitleLogo} className="h-16" />
                    </Link>
                    <div className="flex flex-col items-stretch justify-center text-right">
                        <div className="flex justify-end mb-2">
                            <a href="https://www.facebook.com/tryontitle/" className="ml-2.5">
                                <AiFillFacebook size="1.5rem"/>
                            </a>
                            <a href="https://www.linkedin.com/company/tryon-title-agency-llc/" className="ml-2.5">
                                <AiFillLinkedin size="1.5rem"/>
                            </a>
                        </div>
                        <p className="mb-2">Open M-F 8:00 AM to 8:00 PM, Saturday 9:00 AM - 1:00 PM</p>
                        <p>(919) 277-0123  |  orders@tryontitle.com</p>
                    </div>
                </div>
                <div className="h-28 flex items-center">
                    <p className="mr-auto font-semibold">© 2021 Tryon Title. All rights reserved.</p>
                    <p>Tryon Express Version {config.version}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;